import React from 'react'
import ForgotPassword from '../../../components/Register/ForgotPassword/ForgotPassword.jsx'
export const AdvisorForgotPassword = () => {
  return <ForgotPassword />
}
